import { graphql } from "gql";

const GET_GROUP_AUTHORS = graphql(`
  query GetGroupAuthors(
    $after: String
    $date: DateTime
    $filters: GroupAuthorsFiltersInput
    $first: Int!
    $groupName: String!
    $sortBy: GroupAuthorsSortInput
  ) {
    group(groupName: $groupName) {
      name
      authors(
        after: $after
        date: $date
        filters: $filters
        first: $first
        sortBy: $sortBy
      ) {
        totalCount
        edges {
          node {
            actor
            commit
            groups
            organization
            repository
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`);

const GET_GROUP_DATA = graphql(`
  query GetGroupDataQuery($groupName: String!, $organizationName: String!) {
    group(groupName: $groupName) {
      managed
      name
      organization
      permissions
      serviceAttributes
    }
    organizationId(organizationName: $organizationName) {
      id
      name
    }
  }
`);

const GET_GROUP_EVENT_STATUS = graphql(`
  query GetGroupEventStatus($groupName: String!) {
    group(groupName: $groupName) {
      name
      events(paginate: false) {
        edges {
          node {
            id
            eventStatus
          }
        }
      }
    }
  }
`);

const GET_STAKEHOLDERS = graphql(`
  query GetStakeholders(
    $after: String
    $filters: StakeholdersFiltersInput
    $first: Int!
    $groupName: String!
    $sortBy: GroupStakeholdersSortInput
  ) {
    group(groupName: $groupName) {
      __typename
      name
      stakeholders(
        after: $after
        filters: $filters
        first: $first
        sortBy: $sortBy
      ) {
        totalCount
        edges {
          cursor
          node {
            email
            invitationState
            lastActivity
            lastLogin
            role
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`);

export {
  GET_GROUP_AUTHORS,
  GET_GROUP_DATA,
  GET_GROUP_EVENT_STATUS,
  GET_STAKEHOLDERS,
};
